import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=af5c147c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=af5c147c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c147c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af5c147c')) {
      api.createRecord('af5c147c', component.options)
    } else {
      api.reload('af5c147c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=af5c147c&scoped=true&", function () {
      api.rerender('af5c147c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z7J6MtWY38WQ/JS/comp/PopupDialog.vue"
export default component.exports